import React from "react";
import { ErrorView } from "../ErrorView/ErrorView";

interface ConfigurationErrorProps {
  clientOptions: any;
}

export const ConfigurationError: React.FC<ConfigurationErrorProps> = ({
  clientOptions,
}) => {
  return (
    <ErrorView>
      <p>
        Your client has one or more configuration errors. Please consult the{" "}
        <a href="https://www.npmjs.com/package/@pureweb/cra-template-pureweb-client">
          README
        </a>{" "}
        for details on how to configure the client template.
      </p>
    </ErrorView>
  );
};
